import TaskCard from './TaskCard';
import { RefreshCw, Play, AlertCircle } from 'lucide-react';
import './TaskList.css';

function TaskList({ tasks, onRefresh, onCheck }) {
  const activeTasks = tasks.filter(t => 
    ['running', 'pending', 'retrying', 'reviewing'].includes(t.status)
  );
  
  const completedTasks = tasks.filter(t => 
    ['done', 'failed'].includes(t.status)
  );

  return (
    <div className="task-list">
      <div className="task-list-header">
        <h2>Active Tasks ({activeTasks.length})</h2>
        <div className="actions">
          <button onClick={onCheck} className="btn-check">
            <Play size={16} />
            Run Check
          </button>
          <button onClick={onRefresh} className="btn-refresh-sm">
            <RefreshCw size={16} />
            Refresh
          </button>
        </div>
      </div>

      {activeTasks.length === 0 ? (
        <div className="empty-state">
          <AlertCircle size={48} className="empty-icon" />
          <p>No active tasks</p>
          <span>Spawn a new task to get started</span>
        </div>
      ) : (
        <div className="task-grid">
          {activeTasks.map(task => (
            <TaskCard key={task.id} task={task} />
          ))}
        </div>
      )}

      {completedTasks.length > 0 && (
        <>
          <h3 className="section-title">Completed ({completedTasks.length})</h3>
          <div className="task-grid completed">
            {completedTasks.slice(0, 5).map(task => (
              <TaskCard key={task.id} task={task} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default TaskList;
